import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { width, space } from 'styled-system'
import hoistStatics from 'hoist-non-react-statics'
import {
  Link,
  theme
} from 'pcln-design-system'

export const mapProps = map => Component =>
  hoistStatics(props => <Component {...map(props)} />, Component)

// Use this to mark props as deprecated
export const deprecatedPropType = replacement => (
  props,
  propName,
  componentName
) => {
  if (props[propName]) {
    return new Error(
      `The \`${propName}\` prop is deprecated and will be removed in a future release. Please use \`${replacement}\` instead.`
    )
  }
}

const size = props => {
  switch (props.size) {
    case 'small':
      return {
        fontSize: `${props.theme.fontSizes[0]}px`,
        padding: '7px 12px'
      }
    case 'medium':
      return {
        fontSize: `${props.theme.fontSizes[1]}px`,
        padding: '9.5px 18px'
      }
    case 'large':
      return {
        fontSize: `${props.theme.fontSizes[2]}px`,
        padding: '12px 22px'
      }
    default:
      return {
        fontSize: `${props.theme.fontSizes[1]}px`,
        padding: '9.5px 18px'
      }
  }
}

const ButtonLink = mapProps(({ fullWidth, ...props }) => ({
  width: fullWidth ? 1 : undefined,
  ...props
}))(styled(Link)`
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  text-decoration: none;
  font-family: inherit;
  font-weight: 600;
  line-height: 1.5;
  cursor: pointer;
  border-radius: ${props => props.theme.radius};
  background-color: ${props => props.theme.colors.blue};
  color: ${props => props.theme.colors.white};
  border-width: 0;
  border-style: solid;
  &:disabled {
    opacity: 0.25;
  }
  &:hover {
    background-color: ${props =>
    props.disabled ? null : props.theme.colors.darkBlue};
    text-decoration: none;
    color: ${theme.colors.white};
  }
  &:focus {
    color: ${theme.colors.white};
  }
  ${width} ${size} ${space};
`)

ButtonLink.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  ...width.propTypes,
  ...space.propTypes,
  fullWidth: deprecatedPropType('width')
}

ButtonLink.defaultProps = {
  theme: theme
}

ButtonLink.displayName = 'ButtonLink'

export default ButtonLink
